import * as Yup from 'yup'

import { EMPTY_STRING } from '../../../constants/common'
import {
  REQUEST_PROFILE_HEADER_EDIT_TITLE_FIELD_MAX_LENGTH,
  REQUEST_PROFILE_HEADER_EDIT_TITLE_FIELD_NAME,
} from '../RequestProfileHeaderEditTitleField'

export function getRequestProfileHeaderEditTitleInitialValues(title) {
  return {
    [REQUEST_PROFILE_HEADER_EDIT_TITLE_FIELD_NAME]: title || EMPTY_STRING,
  }
}

export function getRequestProfileHeaderEditTitleValidationSchema(t) {
  return Yup.object({
    [REQUEST_PROFILE_HEADER_EDIT_TITLE_FIELD_NAME]: Yup.string()
      .trim()
      .required(true)
      .max(
        REQUEST_PROFILE_HEADER_EDIT_TITLE_FIELD_MAX_LENGTH,
        t('Error.MaxLengthKey', {
          length: REQUEST_PROFILE_HEADER_EDIT_TITLE_FIELD_MAX_LENGTH,
        })
      ),
  })
}
